import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
const services = [{
  id: 1,
  title: 'Pool Tile Cleaning',
  description: 'Sparkling Pool Tile Restoration',
  image: 'https://cdn.magicpatterns.com/uploads/xkvVoPKZknFpWPNb7vRoNF/sparkling_pool_tile.jpg'
}, {
  id: 2,
  title: 'Acid Wash',
  description: 'Acid Wash for Stubborn Stains',
  image: 'https://cdn.magicpatterns.com/uploads/g26f28y91KwFHq3n36oWfF/acid_wash.png'
}, {
  id: 3,
  title: 'Chlorine Wash',
  description: 'Chlorine Wash for a Fresh Start',
  image: 'https://cdn.magicpatterns.com/uploads/s5zs8HMtJB5cGxgHwqkoHH/chlorine_wash.png'
}, {
  id: 4,
  title: 'Green to Clean',
  description: 'Transform Your Green Pool Back to Crystal Clear',
  image: 'https://cdn.magicpatterns.com/uploads/iaXg1dTAXQcmzXgqSF7ytb/green_to_clean.png'
}];
export function ServicesSection() {
  return <section id="services" className="py-16 md:py-24 px-6 bg-white" data-id="element-162">
      <div className="container mx-auto max-w-7xl" data-id="element-163">
        <div className="text-center mb-12 md:mb-16" data-id="element-164">
          <span className="text-brand-red uppercase text-sm font-bold tracking-wider block mb-3" data-id="element-165">
            Our Services
          </span>
          <h2 className="text-charcoal text-3xl md:text-4xl font-bold uppercase tracking-wide" data-id="element-166">
            Professional Pool Cleaning Services
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-167">
          {services.map(service => <div key={service.id} className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden group flex flex-col" data-id="element-168">
              <div className="relative h-64 overflow-hidden" data-id="element-169">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-170" />
                <div className="absolute inset-0 bg-navy/10 group-hover:bg-transparent transition-colors duration-300" data-id="element-171" />
              </div>

              <div className="p-5 md:p-8 flex flex-col flex-grow" data-id="element-172">
                <h3 className="text-2xl font-bold text-charcoal mb-3" data-id="element-173">
                  {service.title}
                </h3>
                <p className="text-gray-600 mb-6 flex-grow text-lg" data-id="element-174">
                  {service.description}
                </p>
                <a href="#contact" className="inline-flex items-center text-brand-red font-bold hover:text-brand-red-dark transition-colors group/link" data-id="element-175">
                  Learn More
                  <ArrowRightIcon className="ml-2 w-5 h-5 transition-transform group-hover/link:translate-x-1" data-id="element-176" />
                </a>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}